import { faFilter } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import UnForm from "../../../../../Components/Form";
import { IModuloBase } from "../../../../../Context/User";
import {
    IFiltrouserDashboard
} from "../../../../../Interfaces/Users/UsersInterface";
import { UsuarioInterface } from "../../../../../Interfaces/Geral/GestaoUsuarios/UsuariosInterface";

interface IFiltroUsuarioAtendimentoDashProps {
    handleSubmit: (formData: IFiltrouserDashboard) => void;
    Modulos: Array<IModuloBase>;
    lstUsuarios: Array<UsuarioInterface>;
    default?: IFiltrouserDashboard;
}

export default function FiltroUsuarioAtendimentoDash(
    props: IFiltroUsuarioAtendimentoDashProps
) {
    const [Modulos] = useState(props.Modulos);

    function handleSubmit(formData: IFiltrouserDashboard) {
        /**
         * @todo
         * Passar para um método separado (cleanEmptyValues)
         */
        const formDataWithNoEmptyValues = Object.entries(formData).reduce(
            (obj, [key, val]) => ({
                ...obj,
                [key]: val || undefined,
            }),
            {} as IFiltrouserDashboard
        );
        props.handleSubmit(formDataWithNoEmptyValues);
    }

    return (
        <UnForm handleSubmit={handleSubmit} className="mb-4">
            <div className="form-group row mx-0 w-100">
                <div className="col-12">Data de Abertura</div>
                <UnForm.Input
                    type="date"
                    name="DT_ABERTURA_INICIO"
                    wrapperClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    defaultValue={props.default?.DT_ABERTURA_INICIO}
                />
                <UnForm.Input
                    type="date"
                    name="DT_ABERTURA_FIM"
                    wrapperClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    defaultValue={props.default?.DT_ABERTURA_FIM}
                />
            </div>
            <div className="form-group row mx-0 w-100">
                <div className="col-12">Data de Fechamento</div>
                <UnForm.Input
                    type="date"
                    name="DT_FINALIZADO_INICIO"
                    wrapperClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    defaultValue={props.default?.DT_FINALIZADO_INICIO}
                />
                <UnForm.Input
                    type="date"
                    name="DT_FINALIZADO_FIM"
                    wrapperClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    defaultValue={props.default?.DT_FINALIZADO_FIM}
                />
            </div>
            <div className="form-group row mx-0 w-100">
                <UnForm.Select
                    name="ID_TIPO_CASO"
                    wrapperClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    defaultValue={props.default?.ID_TIPO_CASO}
                    label="Módulo"
                >
                    <option></option>
                    {Modulos.map((m) => (
                        <option value={m.ID_MODULO} key={m.ID_MODULO}>
                            {m.DS_MODULO}
                        </option>
                    ))}
                </UnForm.Select>
                <UnForm.Select
                    name="ID_USUARIO"
                    wrapperClassName="col-12 col-md-6 col-lg-12 col-xl-6"
                    defaultValue={props.default?.ID_USUARIO}
                    label="Atendente"
                >
                    <option></option>
                    {props.lstUsuarios.filter(u => u.FL_ATIVO).map((u) => (
                        <option value={u.ID_USUARIO} key={u.ID_USUARIO}>
                            {u.DS_NOME}
                        </option>
                    ))}
                </UnForm.Select>
            </div>

            <UnForm.SubmitButton
                color="dark"
                wrapperClassName="d-flex justify-content-center w-100"
                className="py-4"
                icon={faFilter}
                outline
            />
        </UnForm>
    );
}
